// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const NavItem = (el) => {
  const ui = {
    el,
    body: select('body', document),
    main: select('#main', document),
    toggles: select.all('button.nav-item', document),
    backdrop: select('.global-nav__backdrop'),
  };

  const closeAllSubnavs = () => {
    ui.toggles.forEach((toggle) => {
      toggle.removeAttribute('aria-expanded');
      ui.body.classList.remove('subnav-open');
    });
  }

  const handleToggle = () => {
    var expanded = el.getAttribute('aria-expanded');

    if (expanded) {
      closeAllSubnavs();
    } else {
      closeAllSubnavs();
      el.setAttribute('aria-expanded', 'true');
    }
  }

  const addEvents = () => {
    ui.el.addEventListener('click', () => {
      handleToggle();
    });

    if (ui.backdrop) {
      ui.backdrop.addEventListener('click', () => {
        closeAllSubnavs();
      });
    }

  }

  const init = () => {
    addEvents();
  };

  init();
};

export default NavItem;
